import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Loader from "../../../organisms/loader/Loader";
import { AUDIENCE_GET_RESPONSE_DETIALS } from "../../../endpoints";
import { formatDateDifference, materialName } from "../../utils/tools";

function ResponsesTab({ audienceId, token, materialFilter, onClearFilter }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    axios
      .get(AUDIENCE_GET_RESPONSE_DETIALS(audienceId), { headers: { Authorization: token } })
      .then(({ data }) => { if (alive) setRows(data.records || []); })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [audienceId, token]);

  const filtered = useMemo(() => {
    if (!materialFilter?.learning_material_id) return rows;
    return rows.filter(
      (r) => String(r.learning_material_id) === String(materialFilter.learning_material_id),
    );
  }, [rows, materialFilter]);

  const fmtAnswer = (a) => {
    const ans = a?.answer;
    if (a?.question?.type === "attachment" && ans === "downloaded") return "Downloaded attachment";
    if (Array.isArray(ans)) return ans.join(", ");
    if (typeof ans === "boolean") return ans ? "Yes" : "No";
    return ans ?? "";
  };

  if (loading) return <div className="lp-pad"><Loader /></div>;

  return (
    <div className="lp-pad">
      {materialFilter?.learning_material_id && (
        <div className="lp-filter">
          <span>Filtering by <b>{materialName[materialFilter.material_type] || ""}: {materialFilter.material_name}</b></span>
          <button type="button" className="lp-filter__clear" onClick={onClearFilter}>Clear</button>
        </div>
      )}
      {filtered.length === 0 ? (
        <div className="lp-empty-inline">
          No responses{materialFilter?.learning_material_id ? " for this material" : ""} yet.
        </div>
      ) : filtered.map((r, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className="lp-qa" key={i}>
          <div className="lp-qa__q">
            <b>{r?.attempt?.question?.description}</b>
            <span className="lp-qa__tm">{formatDateDifference(r?.attempt?.created_at)}</span>
          </div>
          <div className="lp-qa__a">
            {fmtAnswer(r?.attempt)}
            <span className="lp-qa__src"> ({materialName[r?.learning_material_type] || ""}: {r?.learning_material_name})</span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ResponsesTab;
